import { render, staticRenderFns } from "./CulturaCastelliSettings.vue?vue&type=template&id=27fc1654&scoped=true"
import script from "./CulturaCastelliSettings.vue?vue&type=script&lang=js"
export * from "./CulturaCastelliSettings.vue?vue&type=script&lang=js"
import style0 from "./CulturaCastelliSettings.vue?vue&type=style&index=0&id=27fc1654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fc1654",
  null
  
)

export default component.exports